import { createFileRoute } from '@tanstack/react-router';
import { QuizScreen } from '../features/quiz/QuizScreen';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/play/$sessionId')({
  component: PlayRoute,
});

function PlayRoute(): React.JSX.Element {
  const { sessionId } = Route.useParams();
  return <RequireAuth role="child">{(me) => <QuizScreen sessionId={sessionId} me={me} />}</RequireAuth>;
}
